import { SignupSkipButton } from "../SignupSkipButton/SignupSkipButton";
import { SignupStepButton } from "../SignupStepButton/SignupStepButton";
import { SignupErrorFeedback } from "../SignupErrorFeedback/SignupErrorFeedback";
import { FormikProps } from "formik";
import { Loader } from "@/components/Common/Loader/Loader";
import { WalletAddressField } from "../WalletAddressField/WalletAddressField";
import { WalletType, getWalletOption } from "@/utils/wallet";
import { ucfirst } from "@/utils/string";
import { useMemo } from "react";
import { WalletAddressStepFormType } from "../WalletAddressStepSlide/WalletAddressStepSlide";
import { trackEvent } from "@/utils/analytics";
import { AnalyticsEventType } from "@/constants/analytics";

type WalletAddressStepSlideFormProps = FormikProps<WalletAddressStepFormType> & {
  walletType: WalletType;
  onPrev?: () => void;
};

export const WalletAddressStepSlideForm: React.FC<WalletAddressStepSlideFormProps> = ({
  walletType,
  isValid,
  isSubmitting,
  handleSubmit,
  errors,
  onPrev
}) => {
  const wallet = useMemo(() => getWalletOption(walletType), [walletType]);
  if (!wallet) {
    return null;
  }

  return (
    <form className="flex flex-1 flex-col items-center justify-center" onSubmit={handleSubmit}>
      <div className="flex w-[380px] flex-col gap-5 text-center">
        <div className="flex flex-col gap-2">
          <h2 className="title-h4 text-white">Connect Your Wallet</h2>
          <div className="flex flex-col gap-2">
            <p className="subtext-x-small text-gray-dark-1000">
              This wallet will be used to send your $IO emission rewards
            </p>
          </div>
        </div>
        {errors.submit && <SignupErrorFeedback>{ucfirst(errors.submit)}</SignupErrorFeedback>}
        <div className="flex flex-col gap-3">
          <WalletAddressField name="walletAddress" walletType={walletType} size={"sm"} />
        </div>
        <div className="flex flex-row items-center gap-5">
          <SignupStepButton
            className="flex-1"
            onClick={() => {
              trackEvent(AnalyticsEventType.BACK_CLICKED);
              onPrev?.();
            }}
          >
            Go back
          </SignupStepButton>
          <SignupStepButton className="flex-1" type="submit" disabled={!isValid || isSubmitting}>
            <span>Next Step</span>
            {isSubmitting && <Loader className="!h-[14px] !w-[14px]" color="#fff" />}
          </SignupStepButton>
        </div>
        <div className="flex flex-row justify-center">
          <SignupSkipButton disabled={isSubmitting} />
        </div>
      </div>
    </form>
  );
};
